import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useGlobalProps } from '@hooks/useGlobalProps';
import { clearUserKeys, getUKeyInLS } from '@utils/ls';
import { SWITCH_ROUTES } from '@constants/routes';
import { useTranslation } from 'react-i18next';
import { logout } from '@api/user';

export default function LogoutPage() {
    const { setUser, noBanner } = useGlobalProps()
    const { t } = useTranslation()
    // const navigate = useNavigate();

    useEffect(() => {
        const handleLogout = async () => {
            const ukey = getUKeyInLS()
            if (ukey) {
                try {
                    await logout({ ukey })
                } catch (error) {
                    console.error('Logout API failed:', error)
                }
            }
            setUser(null)
            clearUserKeys()
            window.location.href = noBanner ? SWITCH_ROUTES.ROOT + window.location.search : SWITCH_ROUTES.ROOT;
            // navigate(SWITCH_ROUTES.ROOT);
        };
        handleLogout().catch(console.error);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100vh',
                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                color: 'white'
            }}
        >
            <div
                style={{
                    width: '40px',
                    height: '40px',
                    border: '4px solid rgba(255, 255, 255, 0.3)',
                    borderTop: '4px solid white',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite',
                    marginBottom: '20px'
                }}
            />
            <p style={{
                fontSize: '18px',
                fontWeight: '500',
                margin: '0'
            }}>
                {t("logout@logging-out")}
            </p>
            <style>{`
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    );
}
